import { render, staticRenderFns } from "./channelFinancial.vue?vue&type=template&id=51b0e089&scoped=true"
import script from "./channelFinancial.vue?vue&type=script&lang=js"
export * from "./channelFinancial.vue?vue&type=script&lang=js"
import style0 from "./channelFinancial.vue?vue&type=style&index=0&id=51b0e089&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0e089",
  null
  
)

export default component.exports